module.exports = __webpack_public_path__ + "static/img/camera.a4908c28.png";